import charts from './chart.js';

($ => {
  'use strict';

  var rendercharts = (chartGroup, location) => {
    var roomtypeUrl = '/admin/charts/roomtypes';
    var utilizeUrl = '/admin/charts/utilized_rooms';
    var roomtypesElem = chartGroup.find('.roomtypes');
    var roomUtilizationElem = chartGroup.find('.utilized_rooms');
    var roomUsageElem = chartGroup.find('.usage_rooms');
    var totalFillElem = chartGroup.find('.fill_rate');

    if (location) {
      roomtypeUrl += '/' + location;
      utilizeUrl += '/' + location;
    }

    $.getJSON(roomtypeUrl, result => {
      charts.roomType(result.results.roomtypes, roomtypesElem[0]);
    });

    $.getJSON(utilizeUrl, result => {
      charts.roomUtilization(
        result.results.utilized_rooms, roomUtilizationElem[0]);

      charts.roomUsage(
        result.results.utilized_rooms, roomUsageElem[0]);

      if (totalFillElem.length) {
        charts.totalFill(
          result.results.utilized_rooms, totalFillElem[0]);
      }
    });
  };

  $('.chartgroup').each((i, elem) => {
    var $el = $(elem);
    rendercharts($el, $el.data('location'));
  });
})(jQuery);
